export default "__VITE_ASSET__cab91fa9__"